module.exports = __webpack_public_path__ + "img/ic_LoadingLarge.c144461b.svg";